import axios, { AxiosError } from 'axios'
import { UserInvitation } from 'components/UserInvitationModal/types'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

export default async function inviteNewUser(values: UserInvitation) {
    const requestBody = {
        email: values.emailAddress,
        first_name: values.firstName,
        last_name: values.lastName,
        level_of_access: values.levelOfAccess,
        application_access: values.applicationAccess,
        ...(values.dealershipId && { dealership_id: values.dealershipId }),
    }

    try {
        const { data } = await axios.post(
            `${config.API_BASE_URL}/api/v3/user_invitation/`,
            requestBody,
            {
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to invite new user: ${axiosError.message}`,
            axiosError,
        )

        throw axiosError
    }
}
